enum PaymentProofStatusEnum {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export default PaymentProofStatusEnum
